<div class="field">
  <app-title
    [isMandatory]="required"
    [title]="title"
    >
  </app-title>
  <div class="input-continer">
    <app-input-text-field
      *ngIf="inputType === 'text'"
      size="sml"
    ></app-input-text-field>
    <span>{{inputSuffixe}}</span>
  </div>
</div>
